export const ENTRY_POINT_STORAGE_KEY = 'entry_point';

export const getEntryPoint = <T>(): T | null => {
    try {
        const entryPoint = sessionStorage.getItem(ENTRY_POINT_STORAGE_KEY);
        sessionStorage.removeItem(ENTRY_POINT_STORAGE_KEY);
        return entryPoint as T;
    } catch {
        return null;
    }
};

export const setEntryPoint = (entryPoint: string): void => {
    try {
        sessionStorage.setItem(ENTRY_POINT_STORAGE_KEY, entryPoint);
    } catch {
        // Silently fail if we can't set the entry point
        // This prevents the app from crashing if sessionStorage is full or blocked
    }
};
